import { render, staticRenderFns } from "./ValueWithIcon.vue?vue&type=template&id=83b1acf2&scoped=true&"
import script from "./ValueWithIcon.vue?vue&type=script&lang=js&"
export * from "./ValueWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./ValueWithIcon.vue?vue&type=style&index=0&id=83b1acf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b1acf2",
  null
  
)

export default component.exports